import { render, staticRenderFns } from "./ShelfHeading.vue?vue&type=template&id=1a555bba&scoped=true&"
import script from "./ShelfHeading.vue?vue&type=script&lang=js&"
export * from "./ShelfHeading.vue?vue&type=script&lang=js&"
import style0 from "./ShelfHeading.vue?vue&type=style&index=0&id=1a555bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a555bba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
